import notification from '../../notification'

export default {
  data(){
    return {
      registerAgreementsState: null,
    }
  },
  computed: {
    registerAgreements() {
      return this.$store.state.agreements.registerAgreements
    }
  },
  mounted() {
     this.getRegisterAgreements()
  },

  methods: {
    getRegisterAgreements() {
      this.$vs.loading()
      this.$store.dispatch('agreements/getRegisterFormAgreements')
        .then(() => {
          this.setRegisterAgreementsInitState()
        })
        .catch(error => {
          this.$vs.notify(notification.error(error.message))
        })
      .finally(() => {
        this.$vs.loading.close()
      })
    },
    setRegisterAgreementsInitState () {
      this.registerAgreementsState = {}
      this.registerAgreements.map(a => {
        this.registerAgreementsState[a.uuid] = false
      })
    },
  }
}